import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'

export const CheckoutLayoutGrid = styled(Box)`
    padding: 40px 20px;
    min-height: 50vh;
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;

    @media screen and (min-width: 600px) {
        padding-top: 60px;
    }

    @media screen and (min-width: 1200px) {
        display: grid;
        grid-template-columns: 770px 370px;
        grid-template-rows: auto auto;
        gap: 22px;
        align-items: flex-start;
        justify-content: center;
        padding-top: 50px;
    }
`
